<template>
    <div class="main-app" :style="'background-color:#fff !important;margin-bottom:0;'">

        <div class="">
                <v-img  v-if="event_id" :src="'https://mediacenter.lpn.co.th/images/company_internal/LPN/Event/banner/event_banner_'+event_id+'.jpg'" class="event_banner hidden-sm-and-up"/>
                <v-img  v-if="event_id" :src="'https://mediacenter.lpn.co.th/images/company_internal/LPN/Event/banner/event_banner_'+event_id+'_desktop.jpg'" class="event_banner hidden-xs-only"/>
        </div>

        <countdown-event v-if="isCountdown&&event_start" :event_start="event_start" :event_name="event_name" />
        <v-container v-else class="container-600">

<!--            <h2 class="my-5 text-lpn">โครงการทั้งหมด</h2>-->
            <div id="properties_items" class="my-5">
                <v-row dense class="">
                    <v-col
                            v-for="(item, i) in project_list"
                            :key="i"
                            class="col-12 col-sm-6 col-md-6 col-lg-6"
                    >
                        <v-card
                                class="mx-auto my-1"
                                max-width="400"
                                outlined
                                :id="'project_'+item.project_id"
                                @click="gotoRoute('eventProjectDetail',genUrl(item))"
                        >
                            <div class="row ma-0" style="height: 180px;">
                                <div class="col-6 pa-0 d-flex flex-column justify-space-between" style="background-color: #e6e6e6;">
                                    <div class="pa-3">
                                        <div>
                                            <div class="text-lpn" style="font-size: 0.85em;line-height: 1.2">{{item.project_name_th}}</div>
                                        </div>
                                        <div class="mt-2">
                                            <div class="grey--text text--accent-4" style="font-size: 0.65em;line-height: 1.2">{{ item.project_caption }}</div>
                                        </div>
                                    </div>
                                    <div v-if="item.price_start" class="d-flex align-center" style="height: 30px;">
                                        <div class="grey--text text--darken-2 pa-1 px-2" style="font-size: 0.75em;line-height: 1.2">ราคาเริ่มต้น
                                            <span class="orange--text text--darken-4 font-weight-bold" style="font-size: 1.15em;">{{ item.price_start | formatNumber3Digit}}</span>
                                            ล้านบาท</div>
                                    </div>
                                    <div class="bg-lpn" :style="'border-left: 8px solid'+getProjectColor(item.project_shortname)+';'">
                                        <v-img
                                                :src="require('@/assets/logo_project/'+item.project_code+'.png')"
                                                @error=""
                                                :alt="item.project_name_th"
                                                contain
                                                position="left"
                                                height="30"
                                        ></v-img>
                                    </div>
                                </div>
                                <div class="col-6 pa-0" :style="'background-image: linear-gradient(to top,rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0)),url(\''+item.pj_image_link+'\');background-repeat: no-repeat;background-size: 100% 100%, cover;background-position: center;'">
                                </div>
                            </div>

                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-container>
        <div v-if="showFloatBtn" class="text-center div_btn_goto d-flex justify-center">
            <div class="col-12 col-md-3">
                <v-btn
                        block
                        rounded
                        color="darken-1"
                        max-width="450"
                        class="text-center bg-lpn  white--text elevation-3"
                        @click="scrollToDiv('#properties_items')"
                >
                    รายชื่อโครงการที่เข้าร่วม
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>

    import CountdownEvent from '@/components/saleOnline/CountdownEvent'

    export default {
        name: "EventProject",
        components:{
            countdownEvent:CountdownEvent
        },
        data(){
            return{
                current_loading_state:{
                    show:false,
                    message:'กำลังโหลดข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                },
                project_list:[],
                isCountdown:false,
                event_start: null,
                event_id: null,
                event_name: '',
                showFloatBtn: true,
                media_ref: {
                    ml: '',
                    ml_mt: '',
                    utm_source: '',
                    utm_medium: '',
                    utm_campaign: '',
                    gclid: '',
                    fbclid: ''
                },
                uid:''
            }
        },
        async mounted(){
            window.scrollTo(0,0)

            //แสดง loading
            this.current_loading_state.show = true
            store.commit('changeLoadingState', this.current_loading_state)

            if(this.$route.query.hasOwnProperty('ev_id')){
                this.event_id = this.$route.query.ev_id


                if(this.$route.query.hasOwnProperty('ml')){
                    this.media_ref.ml = this.$route.query.ml
                }
                if(this.$route.query.hasOwnProperty('ml_mt')){
                    this.media_ref.ml_mt = this.$route.query.ml_mt
                }
                if(this.$route.query.hasOwnProperty('utm_source')){
                    this.media_ref.utm_source = this.$route.query.utm_source
                }
                if(this.$route.query.hasOwnProperty('utm_medium')){
                    this.media_ref.utm_medium = this.$route.query.utm_medium
                }
                if(this.$route.query.hasOwnProperty('utm_campaign')){
                    this.media_ref.utm_campaign = this.$route.query.utm_campaign
                }
                if(this.$route.query.hasOwnProperty('gclid')){
                    this.media_ref.gclid = this.$route.query.gclid
                }
                if(this.$route.query.hasOwnProperty('fbclid')){
                    this.media_ref.fbclid = this.$route.query.fbclid
                }
                if(this.$route.query.hasOwnProperty('uid')){
                    this.uid = this.$route.query.uid
                }


                this.project_list = await this.getProjectList()

                window.addEventListener('resize', this.showFloatButton)
                window.addEventListener('scroll', this.showFloatButton)

                this.$nextTick(() => {
                    this.isCountdown = true

                    this.event_start = this.project_list[0]?.ev_start
                    this.event_name = this.project_list[0]?.ev_name
                    localStorage.setItem('lla_event', JSON.stringify({event_name:this.event_name,event_start:this.event_start}))

                    if(!this.isInViewport("properties_items")){
                        this.showFloatBtn = true
                    }else{
                        this.showFloatBtn = false
                    }
                })

            }else{
                console.log('event_id is empty')
                // main-app
                this.$nextTick(() => {
                    document.querySelector('.main-app').innerHTML = "<div class='v-alert red white--text' style='border-radius: unset;'>Error loading!  ...... Missing some parameter.</div>"
                })
            }

            //ซ่อน loading
            this.current_loading_state.show = false
            store.commit('changeLoadingState', this.current_loading_state)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.showFloatButton)
            window.removeEventListener('scroll', this.showFloatButton)
        },
        metaInfo() {
            return {
                title: this.event_name,
                titleTemplate: '%s - LPN Register',
                script: [
                    {
                        // innerHTML: " !function(f,b,e,v,n,t,s)\n" +
                        //     "  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n" +
                        //     "  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n" +
                        //     "  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n" +
                        //     "  n.queue=[];t=b.createElement(e);t.async=!0;\n" +
                        //     "  t.src=v;s=b.getElementsByTagName(e)[0];\n" +
                        //     "  s.parentNode.insertBefore(t,s)}(window, document,'script',\n" +
                        //     "  'https://connect.facebook.net/en_US/fbevents.js');\n" +
                        //     "  fbq('init', '2479275489050266');\n" +
                        //     "  fbq('track', 'PageView');", type: 'text/javascript', charset: 'utf-8'
                        innerHTML: "!function(f,b,e,v,n,t,s)\n" +
                            "  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n" +
                            "  n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n" +
                            "  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n" +
                            "  n.queue=[];t=b.createElement(e);t.async=!0;\n" +
                            "  t.src=v;s=b.getElementsByTagName(e)[0];\n" +
                            "  s.parentNode.insertBefore(t,s)}(window, document,'script',\n" +
                            "  'https://connect.facebook.net/en_US/fbevents.js');\n" +
                            "  fbq('init', '520335469369318');\n" +
                            "  fbq('track', 'PageView');", type: 'text/javascript', charset: 'utf-8'
                    }
                ],
            };
        },
        created() {

            //แสดงเลข version
            store.commit('changeShowVersionState', false)

            //แสดงเมนูด้านล่าง และกำหนดรายการเมนู
            this.setBottomNav(false)

            this.setTopNav(
                false,
            )

            //ซ่อน flash massage
            store.commit('changeFlashState',{show:false})
        },
        methods:{
            genUrl(item){
                let data = {
                    pj:item.project_id,
                    ev_id: item.ev_id,
                    qj_code: item.qj_code,
                }
                if(this.media_ref.gclid){
                    data.gclid = this.media_ref.gclid
                }
                if(this.media_ref.fbclid){
                    data.fbclid = this.media_ref.fbclid
                }
                if(this.media_ref.ml){
                    data.ml = this.media_ref.ml
                }
                if(this.media_ref.ml_mt){
                    data.ml_mt = this.media_ref.ml_mt
                }
                if(this.media_ref.utm_source){
                    data.utm_source = this.media_ref.utm_source
                }
                if(this.media_ref.utm_medium){
                    data.utm_medium = this.media_ref.utm_medium
                }
                if(this.media_ref.utm_campaign){
                    data.utm_campaign = this.media_ref.utm_campaign
                }
                if(this.uid!==''){
                    data.uid = this.uid
                }

                return data
            },
            showFloatButton(event) {

                if(!this.isCountdown&&!this.isInViewport("properties_items")){
                    this.showFloatBtn = true
                }else{
                    this.showFloatBtn = false
                }
            },
            isInViewport(element_id) {

                if(document.getElementById(element_id)) {
                    let rect = document.getElementById(element_id)
                    let html = document.documentElement
                    let elementTop = rect.offsetTop
                    let elementBottom = elementTop + rect.offsetHeight
                    let viewportTop = html.scrollTop
                    let viewportBottom = viewportTop + html.clientHeight

                    return elementBottom > viewportTop && elementTop < viewportBottom
                }

            },
            async getProjectList(){
                //แสดง loading
                this.current_loading_state.show = true
                store.commit('changeLoadingState', this.current_loading_state)

                const requestBody = {
                    ev_id: this.event_id
                }

                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getEventProjectList', requestBody))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                        // this.project_list = [...promiseChecking.result.res.data.result]
                    }
                }

                //ซ่อน loading
                this.current_loading_state.show = false
                store.commit('changeLoadingState', this.current_loading_state)

                return finalResult

            },
            setEventStart(){
                this.isCountdown=false
            },
            scrollToDiv(elem_id){
                let container = this.$el.querySelector(elem_id);
                if(container) {
                    container.scrollIntoView({behavior: "smooth"})
                }
            }
        }

    }
</script>

<style scoped>
    .event_banner{
        max-width: 700px;
        margin: auto;
    }
    /*.event_banner > .v-responsive__content{*/
    /*    width: auto !important;*/
    /*}*/

    .div_btn_goto{
        position: fixed;
        z-index: 1;
        bottom: 0;
        width: 100%;
    }

    .div_btn_goto:before {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100px;
        bottom: 0;
        left: 0;
        background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 255, 255, 0)), to(#fff));
        background-image: linear-gradient(rgba(255, 255, 255, 0), #fff);
    }

    @media only screen and (max-width: 959px) {
        .event_banner{
            max-width: 960px;
        }
    }
</style>
